import CampaignLayout from "../views/layouts/CampaignLayout";

const routes = [
  {
    path: '/campaign/:name',
    redirect: '/campaign/:name/sign-in'
  },
  {
    path: '/campaign/:name/sign-in',
    name: 'CampaignSignIn',
    component: () => import('../views/SignInView.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/campaign/:name/workout',
    name: "CampaignWorkout",
    component: () => import('@/module_user/views/Workout.vue'),
    beforeEnter: checkUserLogin,
    props: route => ({ id: route.query.id, tryNow: false, withEFTech: 1, withAssist: 0, poseBy:"BP" }),
  },
  {
    path: '/campaign',
    component: CampaignLayout,
    children: [
      {
        path: ':name/introduction',
        name: 'CampaignIntroduction',
        component: () => import('../views/IntroPageView')
      },
      {
        path: ':name//safety-precautions',
        name: 'CampaignSafetyPrecautions',
        component: () => import('../views/SafetyPrecautionsView.vue'),
        props: route => ({ tenantName: route.query.tenantName, id: route.query.id }),
        beforeEnter: checkUserLogin,
      },
      {
        path: ':name//user-details',
        name: 'CampaignUserDetails',
        component: () => import('../views/UserDetailsView.vue'),
        beforeEnter: checkUserLogin,
      },
      {
        path: ':name//leaderboard',
        name: 'CampaignLeaderboard',
        component: () => import('../views/LeaderBoardView.vue'),
        beforeEnter: checkUserLogin,
      },
    ],
    beforeEnter: checkUserLogin,
  },
]

function checkUserLogin(to, from, next) {
  const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : null;
  const rolesToAllow = ['Admin', 'Super Admin'];
  if (userInfo && !userInfo.isAnonymousUser && rolesToAllow.includes(userInfo.role)) {
    if (to.name === 'CampaignSignIn') {
      next(`/campaign/${from.params.name ?? to.params.name }/introduction`);
    } else {
      next();
    }
  }
  else {
    if (to.name === 'CampaignSignIn')
      next()
    else
      next(`/campaign/${from.params.name ?? to.params.name}/sign-in`);
  }
}

export default routes;
